import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';
import {elementIdSchema} from '../../schemas';

const toolName = 'get-form-name' as const;

const argumentZod = z.object({
  elementId: elementIdSchema.describe(
    'The ID of the Form element to get the name from. Must be a FormForm or FormWrapper element.'
  ),
});

export const getFormNameTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get form name',
  llmTool: {
    name: toolName,
    description: dedent`
      Retrieve the name of a form element. Returns the current name of the form
      as a string. Only works with Form elements (FormForm or FormWrapper types).
      This is useful for identifying forms and understanding their configuration.`,
    inputSchema: argumentZod,
  },
  type: 'designer',
  confirmBeforeExecuting: false, // Read-only operation
  timeout: 30000, // 30 seconds for retrieving form name
});
